export default "__VITE_ASSET__9be2acc5__"